import React, { useState } from "react";
import { Button, Modal } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import styled from "styled-components";

import { EmailDocument } from "../../../api/graphql";
import { useUpdateEmailDocumentMutation } from "../../../api/graphql/mutations/updateEmailDocument";
import DeleteEmailDocumentModal from "./DeleteEmailDocumentModal";
import EmailDocumentPreviewOnly, { getAsset } from "./EmailDocumentPreviewOnly";

import { showErrorMessage } from "../../../utils";

export { getAsset };

const AssetPreview = styled.div`
  display: flex;
  flex: 1;
  position: relative;
`;

const BottomButtonWrapper = styled.div`
  position: absolute;
  right: 5px;
  bottom: 5px;
  display: flex;
  gap: 8px;
`;

const ActionButton = styled(Button)``;

const ButtonWrapper = styled.div`
  position: absolute;
  margin: 90px 0 0 50px;
`;

const Preview = ({
  emailDocument,
  fetchNext,
}: {
  emailDocument: EmailDocument;
  fetchNext: () => void;
}) => {
  const [updateEmailDocumentMutation] = useUpdateEmailDocumentMutation();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isSendingToCustomer, setIsSendingToCustomer] = useState(false);

  const sendToCustomer = async () => {
    setIsSendingToCustomer(true);
    try {
      await updateEmailDocumentMutation({
        variables: {
          id: emailDocument.id,
          manualMatchRequired: true,
        },
      });
      fetchNext();
    } catch (error) {
      showErrorMessage("Error during marking as manual match required");
    } finally {
      setIsSendingToCustomer(false);
    }
  };

  const handleSendToCustomerClick = () => {
    Modal.confirm({
      title: "Beleg an Kunden senden",
      content:
        "Dadurch wird ein To-Do für den Kunden erstellt, um den Beleg zuzuordnen.",
      onOk: sendToCustomer,
      okText: "Bestätigen & Senden",
      cancelText: "Abbrechen",
    });
  };

  return (
    <AssetPreview>
      <EmailDocumentPreviewOnly emailDocument={emailDocument} />
      <BottomButtonWrapper>
        {!emailDocument?.manualMatchRequired && (
          <ActionButton
            size="large"
            type="default"
            onClick={handleSendToCustomerClick}
            loading={isSendingToCustomer}
          >
            Send to Customer
          </ActionButton>
        )}
        <ActionButton
          data-test="nextBtn"
          type="primary"
          size="large"
          onClick={fetchNext}
        >
          Next
        </ActionButton>
      </BottomButtonWrapper>
      <ButtonWrapper>
        <Button
          data-test="deleteBtn"
          icon={<DeleteOutlined />}
          size="large"
          danger
          onClick={() => setIsDeleteModalOpen(true)}
        />
      </ButtonWrapper>
      <DeleteEmailDocumentModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onSuccess={() => {
          setIsDeleteModalOpen(false);
          fetchNext();
        }}
        emailDocumentId={emailDocument.id}
      />
    </AssetPreview>
  );
};

export default Preview;
